import { NewsCategoryInsert, NewsCategoryDelete, NewsCategoryUpdate, NewsCategoryGetById, NewsCategoryGetList, NewsCategoryGetPageList } from "@/api/newscategory/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    NewsCategoryInsert(context, payload) {
        return new Promise((resolve, reject) => {
            
            
            NewsCategoryInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    NewsCategoryUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            NewsCategoryUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    NewsCategoryGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            NewsCategoryGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    NewsCategoryGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            NewsCategoryGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    NewsCategoryGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            NewsCategoryGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}